import React from 'react'
import PropTypes from 'prop-types'

import SuggestionReply from '@components/suggestion-reply/suggestion-reply.component'

const ChatMessageSuggestion = ({ disabled, index, messageGuid, messageId, onClick, pressed, suggestion }) => {
  const [suggestionType] = Object.keys(suggestion)

  switch (suggestionType) {
  case 'reply':
    return <SuggestionReply
      disabled={disabled}
      index={index}
      messageGuid={messageGuid}
      messageId={messageId}
      onClick={onClick}
      pressed={pressed}
      suggestion={suggestion}
    />
  default:
    return null
  }
}

ChatMessageSuggestion.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  pressed: PropTypes.bool,
  suggestion: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string,
    action: PropTypes.string
  }).isRequired
}

export default ChatMessageSuggestion
